import React from "react";
import styled from "styled-components";
import logo from "../assets/logo.png";
import logoDetail from "../assets/logo-detail.png";

const FooterSection = styled.section`
  width: 100%;
  background: linear-gradient(180deg, #06121e 0%, #323e49 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 24px;
  position: relative;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 60px 20px;
  }

  @media (max-width: 480px) {
    padding: 40px 16px;
  }
`;

const FooterContainer = styled.div`
  max-width: 1320px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 48px;
`;

const LogoSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  padding: 0 10px; /* Removed excessive top padding */

  @media (max-width: 480px) {
    padding: 0; /* Simplified padding for mobile */
  }
`;

const Logo = styled.img`
  height: 70px;
  display: inline-block;

  @media (max-width: 600px) {
    height: 36px; // Consistent with LogoText
  }
`;

const LogoText = styled.img`
  height: 65px;
  display: inline-block;
  vertical-align: middle;

  @media (max-width: 600px) {
    height: 36px; // Optional: scale down for better fit
  }
`;

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
`;

// const FooterSocialIcons = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   gap: 24px;
//   flex-wrap: nowrap;
// `;

// const SocialIcon = styled.a`
//   width: 54px;
//   height: 54px;
//   border-radius: 50%;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   background: transparent;
//   transition: all 0.3s ease;
//   border: 1px solid rgba(255, 255, 255, 0.3);
//   overflow: hidden;

//   svg {
//     width: 24px;
//     height: 24px;
//     display: block;
//   }

//   path {
//     fill: #ffffff;
//     transition: fill 0.3s ease;
//   }

//   &:hover {
//     background-color: #ffffff;

//     path {
//       fill: #0c1c2c;
//     }
//   }

//   @media (max-width: 480px) {
//     width: 40px;
//     height: 40px;

//     svg {
//       width: 18px;
//       height: 18px;
//     }
//   }
// `;

const FooterNavLinks = styled.div`
  display: flex;
  justify-content: center;
  gap: 48px;
  flex-wrap: wrap;
  padding: 16px 0;

  @media (max-width: 480px) {
    gap: 24px;
  }
`;

const FooterNavLink = styled.a`
  font-family: "Montserrat", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #ffffff;
  text-decoration: none;
  transition: opacity 0.3s ease;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`;

const FooterBottomRow = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  padding-top: 10px;

  @media (max-width: 768px) {
    padding-top: 16px;
  }
`;

const FooterBottomInner = styled.div`
  width: 100%;
  max-width: 1320px;
  padding: 0 120px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 0 24px;
    text-align: center;
  }
`;

const FooterText = styled.div`
  font-family: "Montserrat", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 20px;
  color: #ffffff;

  @media (max-width: 480px) {
    font-size: 16px;
    line-height: 20px;
  }
`;

// const FooterLinksGroup = styled.div`
//   display: flex;
//   gap: 24px;
//   align-items: center;
//   flex-wrap: wrap;
//   justify-content: center;

//   a {
//     font-family: "Montserrat", sans-serif;
//     font-weight: 400;
//     font-size: 18px;
//     line-height: 20px;
//     color: #ffffff;
//     text-decoration: none;

//     &:hover {
//       opacity: 0.8;
//     }
//   }

//   .separator {
//     color: #ffffff;
//     font-size: 18px;
//     user-select: none;
//   }

//   @media (max-width: 480px) {
//     gap: 12px;

//     a,
//     .separator {
//       font-size: 16px;
//     }
//   }
// `;

const FullWidthDivider = styled.div`
  width: 100vw;
  height: 1px;
  background-color: rgba(255, 255, 255, 0.2);
`;

const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <FooterSection>
      <FooterContainer>
        <LogoSection>
          <LogoWrapper>
            <Logo src={logo} alt="Neuora Logo" />
            <LogoText src={logoDetail} alt="Neuora Detail Logo" />
          </LogoWrapper>
          {/* <FooterSocialIcons>
            <SocialIcon //href="#"
              aria-label="Facebook"
            >
              <svg
                width="18"
                height="28"
                viewBox="0 0 18 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ width: "20px", height: "20px" }}
              >
                <g filter="url(#filter0_d_367_80)">
                  <path
                    d="M13.2155 8.13902H10.7174V6.04257C10.7174 4.9608 10.8047 4.27945 12.3423 4.27945H13.2446C13.8185 4.27945 14.2842 3.80984 14.2842 3.23122V1.91674C14.2842 1.36852 13.8673 0.899964 13.3247 0.863276C12.6968 0.820299 12.0678 0.800383 11.4378 0.801431C8.61749 0.801431 6.55914 2.53834 6.55914 5.72705V8.13902H4.48C3.90616 8.13902 3.44043 8.60863 3.44043 9.18725V11.2837C3.44043 11.8623 3.90616 12.3319 4.48 12.3319L6.55914 12.3309V20.7178C6.55914 21.2964 7.02487 21.766 7.59871 21.766H9.67785C10.2517 21.766 10.7174 21.2964 10.7174 20.7178V12.3288L12.9774 12.3277C13.5055 12.3277 13.9494 11.9284 14.0097 11.399L14.2478 9.30675C14.3195 8.68515 13.8372 8.13902 13.2155 8.13902Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_d_367_80"
                    x="0.575484"
                    y="0.801392"
                    width="16.5736"
                    height="26.6945"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="2.86495" />
                    <feGaussianBlur stdDeviation="1.43247" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_367_80"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_367_80"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>
            </SocialIcon>
            <SocialIcon
              // href="#"
              aria-label="YouTube"
            >
              <svg
                viewBox="0 0 28 22"
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="xMidYMid meet"
                style={{ transform: "translateY(2px)" }}
              >
                <path
                  d="M13.6987 0.098999C10.5675 0.098999 7.65826 0.323955 5.9982 0.673661C4.73692 0.959163 3.55925 1.86249 3.31133 3.27711C3.11991 4.42308 2.92529 5.90934 2.92529 8.05108C2.92529 10.1888 3.12057 11.6356 3.36139 12.8357C3.61539 14.2086 4.76588 15.1393 6.03574 15.4256C7.78659 15.7747 10.6137 16.0032 13.745 16.0032C16.8762 16.0032 19.7048 15.7747 21.4378 15.4304C22.7068 15.143 23.8845 14.2397 24.1324 12.8251C24.3218 11.651 24.5649 10.1661 24.6128 8.02099C24.6128 5.85815 24.3691 4.36265 24.1314 3.1781C23.8794 1.80227 22.7276 0.869098 21.4561 0.582414C19.7067 0.33207 16.8305 0.098999 13.6987 0.098999ZM11.8745 4.32451C12.057 4.32071 12.2457 4.36425 12.4232 4.46527L16.6638 6.88137C17.379 7.28892 17.379 8.31721 16.6638 8.72476L12.4232 11.1409C11.7139 11.5444 10.8299 11.0333 10.8299 10.2187V5.38648C10.8299 4.77553 11.3267 4.33593 11.8745 4.32451Z"
                  fill="white"
                />
              </svg>
            </SocialIcon>
            <SocialIcon
              // href="#"
              aria-label="LinkedIn"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 22 22"
                xmlns="http://www.w3.org/2000/svg"
                style={{ width: "20px", height: "20px" }}
              >
                <path
                  d="M5.01233 6.96405H0.806648C0.619993 6.96405 0.46875 7.11536 0.46875 7.30195V20.813C0.46875 20.9997 0.619993 21.1509 0.806648 21.1509H5.01233C5.19898 21.1509 5.35023 20.9997 5.35023 20.813V7.30195C5.35023 7.11536 5.19898 6.96405 5.01233 6.96405Z"
                  fill="white"
                />
                <path
                  d="M2.91097 0.247681C1.38069 0.247681 0.135742 1.49128 0.135742 3.01986C0.135742 4.54912 1.38069 5.79319 2.91097 5.79319C4.44002 5.79319 5.68396 4.54905 5.68396 3.01986C5.68403 1.49128 4.44002 0.247681 2.91097 0.247681Z"
                  fill="white"
                />
                <path
                  d="M15.7092 6.62823C14.0201 6.62823 12.7714 7.35438 12.014 8.17946V7.30194C12.014 7.11535 11.8628 6.96404 11.6761 6.96404H7.64844C7.46179 6.96404 7.31055 7.11535 7.31055 7.30194V20.813C7.31055 20.9996 7.46179 21.1509 7.64844 21.1509H11.8449C12.0316 21.1509 12.1828 20.9996 12.1828 20.813V14.1281C12.1828 11.8755 12.7947 10.9979 14.365 10.9979C16.0751 10.9979 16.2111 12.4048 16.2111 14.244V20.8131C16.2111 20.9997 16.3623 21.151 16.5489 21.151H20.747C20.9336 21.151 21.0849 20.9997 21.0849 20.8131V13.402C21.0849 10.0524 20.4462 6.62823 15.7092 6.62823Z"
                  fill="white"
                />
              </svg>
            </SocialIcon>
            <SocialIcon
              // href="#"
              aria-label="Twitter"
            >
              <svg
                width="25"
                height="26"
                viewBox="0 0 25 26"
                xmlns="http://www.w3.org/2000/svg"
                style={{
                  width: "20px",
                  height: "20px",
                  transform: "translateY(2px)",
                }}
              >
                <g filter="url(#filter0_d_367_4)">
                  <path
                    d="M4.08494 0.751526L11.0724 11.0034L3.74512 19.5474H5.30695L11.7645 12.0178L16.8964 19.5474H21.818L14.5061 8.82013L21.4264 0.751526H19.8655L13.815 7.80576L9.00658 0.751526H4.08494Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_d_367_4"
                    x="0.880172"
                    y="0.751526"
                    width="23.8026"
                    height="24.5257"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="2.86495" />
                    <feGaussianBlur stdDeviation="1.43247" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_367_4"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_367_4"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>
            </SocialIcon>
          </FooterSocialIcons> */}

          <FooterNavLinks>
            <FooterNavLink onClick={() => scrollToSection("home")}>
              Home
            </FooterNavLink>
            <FooterNavLink onClick={() => scrollToSection("features")}>
              Features
            </FooterNavLink>
            <FooterNavLink onClick={() => scrollToSection("usecases")}>
              Market Applications
            </FooterNavLink>
            {/* <FooterNavLink onClick={() => scrollToSection("testimonials")}>
              Testimonials
            </FooterNavLink> */}
            <FooterNavLink onClick={() => scrollToSection("about")}>
              About Us
            </FooterNavLink>
          </FooterNavLinks>
        </LogoSection>

        <FullWidthDivider />

        <FooterBottomRow>
          <FooterBottomInner>
            <FooterText>Copyright © 2025</FooterText>
            <FooterText>Website by neuora.ai</FooterText>
            {/*<FooterLinksGroup>
              <a>FAQ</a>
              <span className="separator">|</span>
              <a>Terms of Use</a>
              <span className="separator">|</span>
              <a>Privacy Policy</a>
            </FooterLinksGroup> */}
          </FooterBottomInner>
        </FooterBottomRow>
      </FooterContainer>
    </FooterSection>
  );
};

export default Footer;
